<template>
  <b-modal
    id="surgery-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer une chirurgie"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selected">
      Supprimer la chirurgie "{{selected.name}}" ?
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'SurgeryDeleteModal',

  props: {
    selected: Object
  },

  emits: ['didDeleteSurgery'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      let surgeryName = this.selected.name

      api
        .delete(`/surgery/${this.selected.id}`)
        .then(response => {
          this.$emit('didDeleteSurgery')
          this.hideModal()
          this.successToast(`Chirurgie \"${surgeryName}\" supprimée`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('surgery-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/surgery/SurgeryDeleteModal.vue